module.exports = __webpack_public_path__ + "img/google-meet-small-logo.89a814fe.png";